import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/tooltip/demos/detached-triggers-controlled/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/tooltip/demos/detached-triggers-controlled/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/tooltip/demos/detached-triggers-full/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/tooltip/demos/detached-triggers-full/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/tooltip/demos/detached-triggers-simple/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/tooltip/demos/detached-triggers-simple/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/tooltip/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/demo-data/theme/css-modules/theme.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.10.1-canary.3_@types+react@19.2.14_next@16.1.7_@babel+core@7_a4d33a659259244c4606358065f42e6b/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CodeHighlighterClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.10.1-canary.3_@types+react@19.2.14_next@16.1.7_@babel+core@7_a4d33a659259244c4606358065f42e6b/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.1.7_@babel+core@7.29.0_@playwright+test@1.59.1_babel-plugin-react-compiler@1.0._01582baedb0408169f7f427edd182fd3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingDelayGroup","useDelayGroup"] */ "/opt/build/repo/packages/react/src/floating-ui-react/components/FloatingDelayGroup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingFocusManager"] */ "/opt/build/repo/packages/react/src/floating-ui-react/components/FloatingFocusManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingPortal","useFloatingPortalNode"] */ "/opt/build/repo/packages/react/src/floating-ui-react/components/FloatingPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingNode","FloatingTree","useFloatingNodeId","useFloatingParentNodeId","useFloatingTree"] */ "/opt/build/repo/packages/react/src/floating-ui-react/components/FloatingTree.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useClick"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useClick.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useClientPoint"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useClientPoint.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useDismiss"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useDismiss.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useFloating"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useFloating.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useFloatingRootContext"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useFloatingRootContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useFocus"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useFocus.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useHover"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useHover.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useHoverFloatingInteraction"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useHoverFloatingInteraction.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useHoverReferenceInteraction"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useHoverReferenceInteraction.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useListNavigation"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useListNavigation.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRole"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useRole.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useSyncedFloatingRootContext"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useSyncedFloatingRootContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTypeahead"] */ "/opt/build/repo/packages/react/src/floating-ui-react/hooks/useTypeahead.ts");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipArrow"] */ "/opt/build/repo/packages/react/src/tooltip/arrow/TooltipArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipPopup"] */ "/opt/build/repo/packages/react/src/tooltip/popup/TooltipPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipPortal"] */ "/opt/build/repo/packages/react/src/tooltip/portal/TooltipPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipPositioner"] */ "/opt/build/repo/packages/react/src/tooltip/positioner/TooltipPositioner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/opt/build/repo/packages/react/src/tooltip/provider/TooltipProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipRoot"] */ "/opt/build/repo/packages/react/src/tooltip/root/TooltipRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipTrigger"] */ "/opt/build/repo/packages/react/src/tooltip/trigger/TooltipTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipViewport"] */ "/opt/build/repo/packages/react/src/tooltip/viewport/TooltipViewport.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/react/src/utils/popups/popupStoreUtils.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/ReactStore.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/StoreInspector.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/useRefWithInit.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Timeout"] */ "/opt/build/repo/packages/utils/src/useTimeout.ts");
